import React from "react";

import Behance from "core/ReusableIcons/Behance";
import Facebook from "core/ReusableIcons/Facebook";
import Dribbble from "core/ReusableIcons/Dribbble";
import Instagram from "core/ReusableIcons/Instagram";
import Twitter from "core/ReusableIcons/Twitter";
import Linkedin from "core/ReusableIcons/Linkedin";

import { Socials } from "./styles";

import colors from "core/colors";

const ProfileHeaderSocials = ({ creatorProfile }) => {
    const iconProps = {
        fillColor: colors.accent.darkMode.suenosBuenos,
        size: "md"
    };

    return (
        <Socials>
            {creatorProfile.facebook && (
                <a
                    data-testid="facebook-link"
                    href={`https://www.facebook.com/${creatorProfile.facebook}`}
                    target="_blank"
                    title={`Creator Facebook username ${creatorProfile.facebook}`}
                >
                    <Facebook {...iconProps} />
                </a>
            )}
            {creatorProfile.twitter && (
                <a
                    data-testid="twitter-link"
                    href={`https://www.twitter.com/${creatorProfile.twitter}`}
                    target="_blank"
                    title={`Creator Twitter username ${creatorProfile.twitter}`}
                >
                    <Twitter {...iconProps} />
                </a>
            )}
            {creatorProfile.dribbble && (
                <a
                    data-testid="dribbble-link"
                    href={`https://www.dribbble.com/${creatorProfile.dribbble}`}
                    target="_blank"
                    title={`Creator Dribbble username ${creatorProfile.dribbble}`}
                >
                    <Dribbble {...iconProps} />
                </a>
            )}
            {creatorProfile.behance && (
                <a
                    data-testid="behance-link"
                    href={`https://www.behance.net/${creatorProfile.behance}`}
                    target="_blank"
                    title={`Creator Behance username ${creatorProfile.behance}`}
                >
                    <Behance {...iconProps} />
                </a>
            )}
            {creatorProfile.linkedin && (
                <a
                    data-testid="linkedin-link"
                    href={`https://www.linkedin.com/${creatorProfile.linkedin}`}
                    target="_blank"
                    title={`Creator LinkedIn username ${creatorProfile.linkedin}`}
                >
                    <Linkedin {...iconProps} />
                </a>
            )}
            {creatorProfile.instagram && (
                <a
                    data-testid="instagram-link"
                    href={`https://www.instagram.com/${creatorProfile.instagram}`}
                    target="_blank"
                    title={`Creator Instagram username ${creatorProfile.instagram}`}
                >
                    <Instagram {...iconProps} />
                </a>
            )}
        </Socials>
    );
};

export default ProfileHeaderSocials;
